import { render, staticRenderFns } from "./AtendimentoManageRoute.vue?vue&type=template&id=17058647"
import script from "./AtendimentoManageRoute.vue?vue&type=script&lang=js"
export * from "./AtendimentoManageRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports